import { DeploymentEnvironment } from "../Entities/DeploymentEnvironment";
import { ConfigOverride } from "../Entities/ConfigOverride";

/**
 * Environment-specific overrides to the default config. 
 * The overrides may not exist for each environment (first Partial{}). 
 * An override may only override some of the settings (second Partial{}). 
 */
export const EnvironmentConfig: Partial<Record<DeploymentEnvironment, ConfigOverride>> = {};

/** overrides for production */
EnvironmentConfig[DeploymentEnvironment.Production] = {
    Values: {
        ApiBaseUrl: "https://invc-mgmt-api-prod.azurewebsites.net/",
        AppInsightsConnectionString: "InstrumentationKey=71cf4471-0611-47ff-8f77-c049764631af;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/;ApplicationId=13689c3f-5d6c-4edc-ba4c-789ea4ccbe9e", // book-13cabs-web-prod
        IsTestModeSupported: false,
        Payment: {
            MpsEndpoint: "https://mps-api-management.azure-api.net/card-rego-service/site",
            PaymentFaqLink: "https://www.13cabs.com.au/app/faqs/"
        },
        StaticContentBaseUrl: "https://book-13cabs-cyhdf8encdbmgmgs.z01.azurefd.net/",
        TrackingLinkBaseUrl: "https://book.13cabs.com.au/b/",
        Auth0: {
            ClientDomain: "13cabsorange.au.auth0.com",
            ClientId: "KmhVg2CWVXDpsfDKFw4o9WK5mL2fZynO",
            CustomDomain: "auth.13cabs.com.au",
            Connection: "13CABS-Public-Users"
        },
        GooglePayEnvironment: "PRODUCTION",
        GoogleMerchantId: "17513882793141533548"
    },

    Features: {
        Dialog2Demo: false,
    },
}

/** 
 *  Overrides for local debug, i.e. code that runs from npm start.
 *  A common change might be to point the ApiBaseUrl to localhost.
 */
EnvironmentConfig[DeploymentEnvironment.LocalDebug] = {
    Values: {
        IsTestModeSupported: true,
        //ApiBaseUrl: 'https://localhost:64461/',

        /** "Booking Websites LocalHost Only" */
        GoogleMapsApiKey: "AIzaSyCC0q_OHzPa0TA2mx9wFh35zqnnUXZcTSM",
    },

    Features: {
        UserFeatureFlags: true,
        DropGoogleTagManager: true
    }
}

/** These overrides apply to all Dev Environments */
EnvironmentConfig[DeploymentEnvironment.Development] = {
    Values: {
        /** "Booking Websites DevTest Not Localhost" */
        GoogleMapsApiKey: "AIzaSyCESHkkfh1pnvJ_7CGcYUA7U4Z8RWEo3ug",
        TrackingLinkBaseUrl: "https://book-dev.13cabs.com.au/b/",
    },
}
